module.exports = __webpack_public_path__ + "img/main2.c959e7e1.jpg";